import React, { ReactNode, useState } from 'react';
import { Container, Flex, Spacer, Box } from '@chakra-ui/react';
import DepartmentModal from '../components/DepartmentModal';
import AccountIntegrationContainer from '../components/AccountIntegrationContainer';
import AnnounceModal from '../components/AnnounceModal';
import NavBar from './NavBar';
import Footer from './Footer';
/* 2026.04.03 初回ログイン時のスライド投稿誘導を非表示
import ImportantNoticeModal from './ImportantNoticeModal';
*/
import ProfileUpdateContainer from './ProfileUpdateContainer';
import { PasswordAuthInduction } from './PasswordAuthInduction';
import { PromotionPopup } from './PromotionModal';

type Props = {
  children: ReactNode;
  sidebarContent: ReactNode;
};

export const layoutWithSidebarLgPaddingTop = '5rem';

function LayoutWithSidebar({ children, sidebarContent }: Props) {
  const [promotionResolved, setPromotionResolved] = useState(false);

  return (
    <Flex minH="100vh" direction="column" overflowX="hidden">
      <AnnounceModal />
      {/* 2026.04.03 初回ログイン時のスライド投稿誘導を非表示
      <ImportantNoticeModal />
      */}
      <PromotionPopup onResolved={() => setPromotionResolved(true)} />
      <DepartmentModal />
      {promotionResolved && (
        <>
          <AccountIntegrationContainer />
          <PasswordAuthInduction />
        </>
      )}
      {/* <ProfileUpdateContainer /> */}
      <NavBar />
      <Flex
        height={{
          base: 'initial',
          lg: '100vh',
        }}
        flexDirection={{
          base: 'column',
          lg: 'row',
        }}
      >
        <Box
          pt={['72px', null, null, layoutWithSidebarLgPaddingTop]}
          flex={1}
          overflowX={'hidden'}
          overflowY={'scroll'}
          id="mainContentContainer"
        >
          <Container pb={[0, 0, 10]} maxW="none">
            {children}
          </Container>
          <Spacer />
          <Footer />
        </Box>
        {/* 後でToggle Menuに変更？ */}
        {/* <Box
          pt={{
            base: 0,
            lg: layoutWithSidebarLgPaddingTop, // flexDirection:rowで横並びになるlg以上の画面ではメインカラムのBoxと同じ値にする必要がある
          }}
          role={'aside'}
        >
          {sidebarContent}
        </Box> */}
      </Flex>
    </Flex>
  );
}

export default LayoutWithSidebar;
